module.exports = __webpack_public_path__ + "static/media/neverland.1cd42ea5.jpg";